/**
 * MSW Overrides: Quotation Quota scenario
 *
 * Returns the real quotation response but with `quota` injected at the
 * top level of the response (alongside `id` and `pricing`).
 * These represent the subscription credit breakdown shown during the
 * booking flow (before the booking is confirmed).
 *
 * Enable by setting ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDES_QUOTATION_QUOTA=true
 * in your .env, then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse, bypass } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';
import type { BookingListQuota, QuotationResponse } from '@cvo/domain';

export const MOCK_QUOTATION_QUOTA: BookingListQuota = {
  consumed: 3,
  availableBefore: 10,
  availableAfter: -1,
};

export function createQuotationQuotaOverrides(baseUrl: string): HttpHandler[] {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.post(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.QUOTATION)}`,
      async ({ request }) => {
        const originalResponse = await fetch(bypass(request));
        const data: QuotationResponse = await originalResponse.json();

        const result = {
          ...data,
          quota: MOCK_QUOTATION_QUOTA,
        };

        console.log('[MSW] quotation quota injected:', result.quota);

        return HttpResponse.json(result);
      },
    ),
  ];
}
